export default "__VITE_ASSET__B1x3ch7s__"